import { IOffer } from '../../../offer/types';

export const showTzarCard = (offer: IOffer) => {
  return offer.isTop3 && (typeof window !== 'undefined' ? !!window.fragments.topOfferCardFragment : true);
};
